/**
 * Application configuration loaded from environment variables
 * All configuration must be accessed through this module
 */

interface ApiConfig {
    baseUrl: string;
    timeout: number;
}

interface AppConfig {
    name: string;
    version: string;
}

interface PaginationConfig {
    defaultPageSize: number;
    maxPageSize: number;
}

interface FeatureFlags {
    enableMockApi: boolean;
}

export interface Config {
    api: ApiConfig;
    app: AppConfig;
    pagination: PaginationConfig;
    features: FeatureFlags;
}

const parseNumber = (value: string | undefined, defaultValue: number): number => {
    const parsed = Number(value);
    return isNaN(parsed) ? defaultValue : parsed;
};

const parseBoolean = (value: string | undefined, defaultValue: boolean): boolean => {
    if (value === undefined) return defaultValue;
    return value.toLowerCase() === 'true';
};

export const config: Config = {
    api: {
        baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api',
        timeout: parseNumber(import.meta.env.VITE_API_TIMEOUT, 30000),
    },
    app: {
        name: import.meta.env.VITE_APP_NAME || 'BioSAM CRM',
        version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    },
    pagination: {
        defaultPageSize: parseNumber(import.meta.env.VITE_DEFAULT_PAGE_SIZE, 10),
        maxPageSize: parseNumber(import.meta.env.VITE_MAX_PAGE_SIZE, 100),
    },
    features: {
        enableMockApi: parseBoolean(import.meta.env.VITE_ENABLE_MOCK_API, false),
    },
};

export default config;
